// Packages
import { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';

// Actions
import useApi from "../../../../api";

const useRolesView = () => {
  // State
  const [listRoles, setListRoles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [paginationSettings, setPaginationSettings] = useState({ current: 1, totalPages: 1 });
  const [modalDelete, setModalDelete] = useState({ show: false, name: "", id: 0 });
  const navigation = useNavigate();

  // Actions
  const { useActions } = useApi();
  const { useRolesActions, dispatch } = useActions();
  const { actListRoles, actSelectRole, actDeleteRole } = useRolesActions();

  const { control } = useForm({
    mode: "all",
  });

  const loadData = (data) => {
    setListRoles(data.data);
    setPaginationSettings({ current: data.meta.current_page, totalPages: data.meta.last_page });
  };

  const loadDataPagination = (data) => {
    setListRoles(data.data);
  };

  const handleCreateNewRole = () => {
    navigation("/roles/creacion");
  };

  const handleEditRole = (role) => {
    dispatch(actSelectRole({ role }));
    navigation(`/roles/editar/${role.id}`);
  };

  const handlePagination = (nro) => {
    actListRoles({ page: nro.selected + 1, search: searchText }, loadDataPagination);
  };

  const onSubmitSearch = (e) => {
    setSearchText(e);
    actListRoles({ page: 1, search: e }, loadData);
  };

  const onChangeSearch = useCallback(
    debounce(onSubmitSearch, 750),
    []
  );

  useEffect(() => {
    actListRoles({ page: 1 }, loadData);
  }, []);

  const handleDeleteRole = (id, name) => {
    setModalDelete({ show: true, name: name, id: id });
  };

  const handleConfirmDelete = () => {
    const onSuccessDelete = () => {
      actListRoles({ page: 1 }, loadData);
    };
    actDeleteRole(modalDelete.id, onSuccessDelete);
    setModalDelete({ show: false, name: "", id: 0 });
  };

  const handleCloseModal = () => {
    setModalDelete({ show: false, name: "", id: 0 });
  };

  return {
    control,
    listRoles,
    handleCreateNewRole,
    handleEditRole,
    paginationSettings,
    handlePagination,
    onChangeSearch,
    handleDeleteRole,
    modalDelete,
    handleCloseModal,
    handleConfirmDelete,
  };
};

export default useRolesView;
